<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced.  * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<main class="main">
<!-- main content area -->      
<div id="main" class="wrapper clearfix">  

  <header class="wrapper clearfix">
    <nav id="topnav" role="navigation">
        <div class="menu-toggle">Menu</div>  
        	<ul class="srt-menu" id="menu-main-navigation">
            <li class="current"><a routerLink="/home">Home</a></li>
            <li class="current"><a routerLink="/invoice">Invoice</a></li>
            <li class="current"><a routerLink="/stock">Stock</a></li>            
            <li class="current"><a routerLink="/delivery">Delivery For Fee</a></li>
            <li class="current"><a routerLink="/customer">Customer</a></li>
            <li class="current"><a routerLink="/employee">Employee</a></li>
            <li class="current"><a routerLink="/product">Product</a></li>
            &nbsp;&nbsp;&nbsp;
            <button class="cancel btn btn-warning" (click)="onLogout()">Logout</button>
        </ul>
            
        </nav>
</header>

<div class="jumbotron">
    <div class="container">
        <div class="col-sm-12 col-sm-offset-0">
            <strong>ActiveNotify</strong>
            <!--<app-login></app-login>-->
            <router-outlet/>
        </div>
    </div>
</div>

        <!--<app>Loading...</app>    -->    

</div><!-- #end div #main .wrapper -->


<!-- footer area -->    
<footer>
<div id="colophon" class="wrapper clearfix">
<h2>ActiveNotify - Turfview V2</h2>
Built by  <a href="https://www.evidia.com">Evidia Ltd</a> &copy; Copyright {{calendarYear}} all rights reserved
</div>

</footer><!-- #end footer area --> 


</main>
